import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer id="contact" className="bg-[#153223] text-white py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col items-center text-center gap-8">
          <div className="flex flex-col items-center gap-4">
            <img 
              src="https://static.readdy.ai/image/80fafa544acf55a90d716b5bdc1b1a54/d0ca68546255ea784fe6ebf2c5df36a2.png" 
              alt="OHT Academy Logo" 
              className="w-20 h-20 object-contain"
            />
            <h3 className="font-['Yeseva_One',serif] text-4xl text-[#FFE66D] mb-3">
              OHT Tuition Academy
            </h3>
            <p className="text-[#F5F1E8] text-lg">
              A Home-based learning tuition centre in Bukit Damansara, KL, Malaysia
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 items-center">
            <a 
              href="https://wa.link/zxuf0o" 
              target="_blank" 
              rel="noopener noreferrer"
              className="whitespace-nowrap bg-[#25D366] hover:bg-[#20BD5A] text-white font-semibold px-6 py-3 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer flex items-center gap-2"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              WhatsApp Contact
            </a>
            
            <Link 
              to="/level-test-registration"
              className="whitespace-nowrap bg-[#FFE66D] hover:bg-[#FFD93D] text-[#153223] font-semibold px-6 py-3 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer flex items-center gap-2"
            >
              <i className="ri-file-list-3-line text-xl"></i>
              Register for a Free Online Level Test
            </Link>
          </div>
        </div>

        <div className="border-t border-[#2d5a3f] mt-10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#F5F1E8] text-sm">
            © 2025 OHT Tuition Academy. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-[#F5F1E8] hover:text-[#FFE66D] text-sm transition-colors duration-300 cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
